<template>
  <v-dialog v-model="dialog" max-width="40%">
    <template v-slot:activator="{ on }">
      <slot name="button" :on="on">
        <v-btn icon small v-on="on">
          <v-icon small>edit</v-icon>
        </v-btn>
      </slot>
    </template>
    <v-card>
      <v-card-title class="headline">
        <slot name="title">
          <div>Edit Industry Name</div>
        </slot>
        <v-spacer />
        <v-btn icon @click="close"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <v-form v-model="$v.valid" @submit.prevent="submit">
          <v-text-field
            v-model.trim="$v.formdata.name.$model"
            :error-messages="nameErrors"
            :label="formdata.label"
            :counter="formdata.counter"
            :prepend-icon="formdata.icon"
            :hint="formdata.hint"
            @input="$v.formdata.name.$touch()"
            @blur="$v.formdata.name.$touch()"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text color="red" class="mx-1" @click="close">
          Close
        </v-btn>
        <v-btn
          text
          @click="submit"
          :disabled="$v.$invalid"
          color="success"
          class="mx-1"
        >
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { validationMixin } from "vuelidate";
import { handleErrors } from "../../services/formErrors";
import Industry from "../../models/Industry";
export default {
  name: "IndustryFormEdit",
  mixins: [validationMixin],
  validations: Industry.validations,
  props: {
    instance: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data() {
    return {
      formdata: new Industry(this.instance),
      dialog: false,
    };
  },
  computed: {
    nameErrors() {
      return handleErrors("formdata", "name", this);
    }
  },
  methods: {
    submit() {
      this.$v.$touch();
      Industry
        .$put(this.instance.id, this.formdata.toUpdatePayload())
        .then(() => this.close());
    },
    close() {
      this.dialog = false;
    },
    clear() {
      this.$v.$reset();
    }
  }
};
</script>
